import { supabase } from '@/integrations/supabase/client';
import { notificationEventKey, runOnceInFlight } from '@/lib/notificationEvents';

/**
 * Notification triggers.
 *
 * Durable de-duplication lives on the server: `notify-quote` writes a unique
 * `event_key` per logical event + recipient. The in-flight guard here only stops
 * a double-clicked button from firing the same request twice.
 */
export async function notifyQuoteSubmitted(quoteId: string) {
  await runOnceInFlight(notificationEventKey(['quote_submitted', quoteId]), async () => {
    try {
      await supabase.functions.invoke('notify-quote', {
        body: { type: 'quote_submitted', quoteId },
      });
    } catch (err) {
      console.error('Failed to send submission notification:', err);
    }
  });
}

export async function notifyQuoteStatusChanged(quoteId: string, newStatus: string) {
  await runOnceInFlight(notificationEventKey(['quote_status_changed', quoteId, newStatus]), async () => {
    try {
      await supabase.functions.invoke('notify-quote', {
        body: { type: 'quote_status_changed', quoteId, newStatus },
      });
    } catch (err) {
      console.error('Failed to send status notification:', err);
    }
  });
}

export async function notifyPOStatusChanged(poId: string, newStatus: string) {
  await runOnceInFlight(notificationEventKey(['po_status_changed', poId, newStatus]), async () => {
    try {
      await supabase.functions.invoke('notify-quote', {
        body: { type: 'po_status_changed', poId, newStatus },
      });
    } catch (err) {
      console.error('Failed to send PO status notification:', err);
    }
  });
}

export async function notifyPOSubmitted(poId: string) {
  await runOnceInFlight(notificationEventKey(['po_submitted', poId]), async () => {
    try {
      await supabase.functions.invoke('notify-quote', {
        body: { type: 'po_submitted', poId },
      });
    } catch (err) {
      console.error('Failed to send PO submission notification:', err);
    }
  });
}

export async function notifyDealerRegistered(dealerName: string, dealerCompany: string, dealerEmail: string) {
  try {
    await supabase.functions.invoke('notify-quote', {
      body: { type: 'dealer_registered', dealerName, dealerCompany, dealerEmail },
    });
  } catch (err) {
    console.error('Failed to send dealer registration notification:', err);
  }
}

export async function notifyDealerApproved(dealerEmail: string, dealerName: string) {
  try {
    await supabase.functions.invoke('notify-quote', {
      body: { type: 'dealer_approved', dealerEmail, dealerName },
    });
  } catch (err) {
    console.error('Failed to send dealer approval notification:', err);
  }
}

export async function notifyDealerRejected(dealerEmail: string, dealerName: string) {
  try {
    await supabase.functions.invoke('notify-quote', {
      body: { type: 'dealer_rejected', dealerEmail, dealerName },
    });
  } catch (err) {
    console.error('Failed to send dealer rejection notification:', err);
  }
}
